import "../styles/TweetTest.css";

import React from "react";

const Tweet = () => {
    return (
        <article>
            Test
        </article>
    )
}

export default Tweet;
